import React, {useState, useEffect, useRef, useMemo} from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import countryOptions from "../../../components/List/Countries";
import { Checkbox, IconButton } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Button from "@mui/material/Button";
import {Link, useLocation, useNavigate} from "react-router-dom";
import CrudService from "services/cruds-service";
import {LocalizationProvider, DatePicker} from "@mui/x-date-pickers";
import "jspdf-autotable";
import { tr } from "date-fns/locale";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DataTable from "../../../../../../../examples/Tables/DataTable";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InputAdornment from "@mui/material/InputAdornment";
import { CrmPageHeader, CrmNotice, crmCardSx } from "../../shared/CrmUi";

const IntermodalForm = ({ selectedTransportType }) => {
    const initialAddressStatePickup = {
        additionalInfo: "",
        selectedPickupCountry:"",
        pickupCity:""
    };
    const initialAddressStateDelivery = {
        additionalInfo: "",
        selectedDeliveryCountry:"",
        deliveryCity:""
    };

    const statusOptions = [
        { label: "Prospect" },
        { label: "Needs Assessment" },
        { label: "Target" },
        { label: "Secured" },
        { label: "Lost" },
    ];

    const frequencyOptions = [
        { label: "Weekly" },
        { label: "Monthly" },
        { label: "Yearly" },
    ];

    const containerOptions = [
        { label: "20'DC" }, // Standart Kamyon
        { label: "40'HC" }, // Soğutuculu Kamyon
    ];

    const truckType = [
        { label: "HCPW (High Cube Pallet Wide)" },
        { label: "45' HC (High Cube)" },
        { label: "Swap Body" },
        { label: "40' HC (High Cube)" },
        { label: "20' DC (Dry Container)" },
    ];

    const paymentPerformanceOptions = [
        { label: "On-Time" },
        { label: "Delayed" },
        { label: "Risky" },
    ];

    const priceComparisonOptions = [
        { label: "Higher" },
        { label: "Lower" },
        { label: "Similar" },
        { label: "Avarage" },
    ];

    const loyaltyOptions = [
        { label: "1" },
        { label: "2" },
        { label: "3" },
        { label: "4" },
        { label: "5" },
    ];

    const customerCategoryOptions = [
        { label: "Existing Customer" },
        { label: "New Customer" },
        { label: "Potential Customer" },
        { label: "Global Agent" }
    ];

    const forwarderOptions = [
        { label: "Freight Forwarder" },
        { label: "Logistics Company (Asset Based)" },
    ];

    const statusMap = {
        Prospect:           { barValue: 20,  labelValue: 20,  color: "#FFB300" },
        "Needs Assessment": { barValue: 50,  labelValue: 50,  color: "#8E24AA" },
        Target:             { barValue: 70,  labelValue: 70,  color: "#053b97" },
        Secured:            { barValue: 100, labelValue: 100, color: "#4CAF50" },
        Lost:               { barValue: 5,   labelValue: 0,   color: "#F44336" }, // özel kural
    };

    const StatusDot = ({ status, size = 10 }) => (
        <span
            style={{
                width: size,
                height: size,
                borderRadius: 999,
                display: "inline-block",
                backgroundColor: statusMap[status]?.color || "#999",
                flexShrink: 0,
                alignSelf: "center",
            }}
        />
    );

    const [salesRepOptions, setSalesRepOptions] = useState([]);

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;

                const formattedUsers = users.map(user => ({
                    id: user.id,
                    label: user.attributes.name
                }));

                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            }
        };

        fetchSalesReps();
    }, []);

    // Doluluk çubuğu: renkli kısım value% genişliğinde
    function ProgressBar({ barValue, color }) {
        return (
            <Box
                sx={{
                    width: "100%",
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: "#ECEFF1",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        width: `${barValue}%`,
                        height: "100%",
                        backgroundColor: color,
                        transition: "width 300ms ease",
                    }}
                />
            </Box>
        );
    }

    const location = useLocation();
    const navigate = useNavigate();
    const isFromMeetings = location.state?.fromMeetings || false; // Eğer state içinde "fromMeetings" varsa true olur
    const [customerOptions, setCustomerOptions] = useState([]); // Options for Autocomplete
    const [opportunityData, setOpportunityData] = useState(null);


    useEffect(() => {
        const fetchCustomersAndGlobalAgents = async () => {
            try {
                const [customerResponse, globalAgentResponse] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents()
                ]);

                const customerList = customerResponse.data.map((customer) => ({
                    name: customer.attributes?.name || "Unnamed Customer",
                    id: customer.id,
                    email: customer.attributes?.email || "customer@example.com",
                    type: "Customer",
                }));

                const globalAgentList = globalAgentResponse.data.map((agent) => ({
                    name: agent.attributes?.name || "Unnamed Global Agent",
                    id: agent.id,
                    email: agent.attributes?.email || "globalAgent@example.com",
                    type: "GlobalAgent",
                }));

                const combinedOptions = [...customerList, ...globalAgentList];

                setCustomerOptions(combinedOptions);

            } catch (error) {
                console.error("Müşteri ve Global Agent verileri alınırken hata:", error);
            }
        };

        fetchCustomersAndGlobalAgents();
    }, []);


    const [formData, setFormData] = useState({
        customer: "",
        opportunityName: "",
        salesRep: "",
        salesTeam:"",
        pickupLocation: "",
        deliveryLocation: "",
        pickupDate: null,
        estimatedStartDate: null,
        estimatedEndDate: null,
        estimatedCloseDate: null,
        frequency: "",
        status: "",
        lostReason: "",
        originFreeTime: "",
        description: "",
        selectedTransportType: selectedTransportType || "",
        selectedCountry: "",
        truckType: "",
        avgMonthlyShipment: 0,
        avgWeight: 0,
        avgCBM: 0,
        container: "",
        freightRate: 0,
        freightRateCurrency: "",
        totalRevenue: 0,
        grossProfitType: "",
        perTruckProfit: "",
        perTruckGrossProfit: 0,
        percentageProfit: "",
        percentageGrossProfit: 0,
        pricePer20DC: "",
        pricePer40HC: "",
        container20DC: "",
        container40HC: "",
        totalRevenueSum: 0,
        totalPerTruckProfitSum: 0,
        totalPercentageGrossProfitSum: 0,
        paymentTerms:"",
        paymentPerformance:"",
        operationalChallenges:"",
        competingFreightForwarders:"",
        competingTransportCompanies:"",
        priceComparison:"",
        loyalty:"",
        customerCategory:"",
        winRate:"",
        transitHubs:"",
        transportModeIntermodal:"",
        lastFollowupDate: null,
        nextFollowupDate: null,
        lastMeetingDate: null,
        nextMeetingDate: null,
        forwarder:"",
        estimatedBuyingRates:"",
        grossProfitRate:""
    });

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            selectedTransportType: selectedTransportType,
        }));
    }, [selectedTransportType]);

    const [loading, setLoading] = useState(false); // Yüklenme durumu
    const [isEditing, setIsEditing] = useState(false); // Düzenleme modu
    const searchParams = new URLSearchParams(location.search); // Query parametrelerini yakalıyoruz
    const opportunityId = searchParams.get("id"); // URL'deki `id` parametresini alıyoruz
    const [successMessage, setSuccessMessage] = useState("");
    const successMessageRef = useRef(null); // Ref oluşturuldu

    // Eğer opportunityId varsa düzenleme modundayız ve veriyi çekiyoruz
    useEffect(() => {
        if (opportunityId) {
            setIsEditing(true); // Düzenleme modunu etkinleştiriyoruz
            fetchOpportunityDetails(opportunityId); // opportunity detaylarını çekiyoruz
        }
    }, [opportunityId]);

    const fetchOpportunityDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getOpportunityById(id);
            const opportunityData = response.data.attributes;
            // Müşteri ve Temsilci Seçenekleri
            const matchedCustomer = customerOptions.find(
                (opt) =>
                    opt.name?.trim().toLowerCase() ===
                    opportunityData.customer?.trim().toLowerCase()
            );
            setOpportunityData(opportunityData); // 📌 Yeni state'e atıyoruz!

            setSelectedCustomer(matchedCustomer || null);

            setSalesRep(
                Array.isArray(opportunityData.salesRep)
                    ? salesRepOptions.filter(repOption =>
                        opportunityData.salesRep.includes(repOption.id)
                    )
                    : []
            );
            setSalesTeam(
                Array.isArray(opportunityData.salesTeam)
                    ? salesRepOptions.filter(repOption =>
                        opportunityData.salesTeam.includes(repOption.id)
                    )
                    : []
            );
            setSelectedStatus(opportunityData.status || "");
            setOpportunityName(opportunityData.opportunityName || "");

            // Adres bilgileri
            setPickupLocation({
                additionalInfo: opportunityData.pickupLocation?.additionalInfo || "",
                pickupCity: opportunityData.pickupLocation?.pickupCity || "",
                selectedPickupCountry: opportunityData.pickupLocation?.selectedPickupCountry || "",
            });
            setSelectedPickupCountry(
                countryOptions.find(opt => opt.label === opportunityData.pickupLocation?.selectedPickupCountry) || null
            );

            setDeliveryLocation({
                additionalInfo: opportunityData.deliveryLocation?.additionalInfo || "",
                deliveryCity: opportunityData.deliveryLocation?.deliveryCity || "",
                selectedDeliveryCountry: opportunityData.deliveryLocation?.selectedDeliveryCountry || "",
            });
            setSelectedDeliveryCountry(
                countryOptions.find(opt => opt.label === opportunityData.deliveryLocation?.selectedDeliveryCountry) || null
            );

            setEstimatedCloseDate(opportunityData.estimatedCloseDate ? new Date(opportunityData.estimatedCloseDate) : null);
            setEstimatedStartDate(opportunityData.estimatedStartDate ? new Date(opportunityData.estimatedStartDate) : null);
            setEstimatedEndDate(opportunityData.estimatedEndDate ? new Date(opportunityData.estimatedEndDate) : null);
            setLastFollowupDate(opportunityData.lastFollowupDate ? new Date(opportunityData.lastFollowupDate) : null);
            setNextFollowupDate(opportunityData.nextFollowupDate ? new Date(opportunityData.nextFollowupDate) : null);
            setLastMeetingDate(opportunityData.lastMeetingDate ? new Date(opportunityData.lastMeetingDate) : null);
            setNextMeetingDate(opportunityData.nextMeetingDate ? new Date(opportunityData.nextMeetingDate) : null);
            setSelectedFrequency(opportunityData.frequency || "");
            setLostReason(opportunityData.lostReason || "");
            setAvgMonthlyShipment(opportunityData.avgMonthlyShipment || "");
            setAvgWeight(opportunityData.avgWeight || "");
            setAvgCBM(opportunityData.avgCBM || "");
            setDescription(opportunityData.description || "");
            setSelectedTransport(truckType.find(opt => opt.label.toLowerCase() === opportunityData.truckType?.toLowerCase()) || null);
            setSelectedContainers(containerOptions.find(opt => opt.label.toLowerCase() === opportunityData.containers?.toLowerCase()) || null);
            setFreightRate(opportunityData.freightRate || "");
            setFreightRateCurrency(opportunityData.freightRateCurrency || "");
            setTotalRevenue(opportunityData.totalRevenue || 0);
            setGrossProfitType(opportunityData.grossProfitType || "");
            setPerTruckProfit(opportunityData.perTruckProfit !== undefined ? opportunityData.perTruckProfit : "");
            setPercentageProfit(opportunityData.percentageProfit !== undefined ? opportunityData.percentageProfit : "");
            setPerTruckGrossProfit((parseFloat(perTruckProfit) || 0) * (parseFloat(avgMonthlyShipment) || 0));
            setPercentageGrossProfit(totalRevenue * ((parseFloat(percentageProfit) / 100) || 1));
            setPricePer20DC(opportunityData.pricePer20DC || "");
            setPricePer40HC(opportunityData.pricePer40HC || "");
            setContainer20DC(opportunityData.container20DC || "");
            setContainer40HC(opportunityData.container40HC || "");
            setTotalRevenueSum(opportunityData.totalRevenueSum || 0);
            setTotalPerTruckProfitSum(opportunityData.totalPerTruckProfitSum || 0);
            setTotalPercentageGrossProfitSum(opportunityData.totalPercentageGrossProfitSum || 0);
            setPaymentTerms(opportunityData.paymentTerms || "");
            setSelectedPaymentPerformance(opportunityData.paymentPerformance || "");
            setOperationalChallenges(opportunityData.operationalChallenges || "");
            setCompetingFreightForwarders(opportunityData.competingFreightForwarders || "");
            setCompetingTransportCompanies(opportunityData.competingTransportCompanies || "");
            setSelectedPriceComparison(opportunityData.priceComparison || "");
            setSelectedLoyalty(opportunityData.loyalty || "");
            setSelectedCustomerCategory(opportunityData.customerCategory || "");
            setWinRate(opportunityData.winRate || "");
            setTransitHubs(opportunityData.transitHubs || "");
            setTransportModeIntermodal(opportunityData.transportModeIntermodal || "");
            setSelectedForwarder(opportunityData.forwarder || "");
            setEstimatedBuyingRates(opportunityData.estimatedBuyingRates || "");
            setGrossProfitRate(opportunityData.grossProfitRate || "");
            setSelectedStrategies(opportunityData.strategies || []);
            setSelectedKeyMarkets(opportunityData.selectedKeyMarkets || {});
            setFormData({
                customer: matchedCustomer?.name || "Unknown Customer",
                opportunityName: opportunityData.opportunityName || "",
                salesRep: opportunityData.salesRep || "",
                salesTeam: opportunityData.salesTeam || "",
                quoteNo: opportunityData.quoteNo || "",
                description: opportunityData.description || "",
                originFreeTime: opportunityData.originFreeTime || "",
                pickupLocation: opportunityData.pickupLocation || {},
                deliveryLocation: opportunityData.deliveryLocation || {},
                estimatedCloseDate: opportunityData.estimatedCloseDate || null,
                estimatedStartDate: opportunityData.estimatedStartDate || null,
                estimatedEndDate: opportunityData.estimatedEndDate || null,
                lastFollowupDate: opportunityData.lastFollowupDate || null,
                nextFollowupDate: opportunityData.nextFollowupDate || null,
                lastMeetingDate: opportunityData.lastMeetingDate || null,
                nextMeetingDate: opportunityData.nextMeetingDate || null,
                selectedTransportType: opportunityData.selectedTransportType || "",
                frequency: opportunityData.frequency || "",
                lostReason: opportunityData.lostReason || "",
                avgMonthlyShipment: opportunityData.avgMonthlyShipment || "",
                avgWeight: opportunityData.avgWeight || "",
                avgCBM: opportunityData.avgCBM || "",
                truckType: opportunityData.truckType || "",
                containers: opportunityData.containers || "",
                freightRate: opportunityData.freightRate || "",
                freightRateCurrency: opportunityData.freightRateCurrency || "",
                totalRevenue: opportunityData.totalRevenue || "",
                grossProfitType: opportunityData.grossProfitType || "",
                perTruckProfit: opportunityData.perTruckProfit || "",
                perTruckGrossProfit: opportunityData.perTruckGrossProfit || 0,
                percentageProfit: opportunityData.percentageProfit || "",
                percentageGrossProfit: opportunityData.percentageGrossProfit || 0,
                pricePer20DC: opportunityData.pricePer20DC || "",
                pricePer40HC: opportunityData.pricePer40HC || "",
                container20DC: opportunityData.container20DC || "",
                container40HC: opportunityData.container40HC || "",
                totalRevenueSum: opportunityData.totalRevenueSum || 0,
                totalPerTruckProfitSum: opportunityData.totalPerTruckProfitSum || 0,
                totalPercentageGrossProfitSum: opportunityData.totalPercentageGrossProfitSum || 0,
                paymentTerms: opportunityData.paymentTerms || "",
                paymentPerformance: opportunityData.paymentPerformance || "",
                operationalChallenges: opportunityData.operationalChallenges || "",
                competingFreightForwarders: opportunityData.competingFreightForwarders || "",
                competingTransportCompanies: opportunityData.competingTransportCompanies || "",
                priceComparison: opportunityData.priceComparison || "",
                loyalty: opportunityData.loyalty || "",
                customerCategory: opportunityData.customerCategory || "",
                winRate: opportunityData.winRate || "",
                transitHubs: opportunityData.transitHubs || "",
                transportModeIntermodal: opportunityData.transportModeIntermodal || "",
                forwarder: opportunityData.forwarder || "",
                estimatedBuyingRates: opportunityData.estimatedBuyingRates || "",
                grossProfitRate: opportunityData.grossProfitRate || "",

            });
        } catch (error) {
            console.error("Error fetching Opportunity details:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (location.state) {
            // ✅ Müşteri bilgisini kaybetme
            if (location.state.customer) {
                setSelectedCustomer({ name: location.state.customer });
            }

            // ✅ meetingDate otomatik doldur
            if (location.state.meetingDate) {
                const parsedDate = new Date(location.state.meetingDate);
                if (!isNaN(parsedDate.getTime())) {
                    setLastMeetingDate(parsedDate);
                }
            }
        }
    }, [location.state]);

    useEffect(() => {
        if (customerOptions.length > 0) {
            fetchOpportunityDetails(opportunityId); // customerOptions hazır olduğunda çağır
        }
    }, [customerOptions, opportunityId]);


    const [pickupLocation, setPickupLocation] = useState(initialAddressStatePickup);
    const [deliveryLocation, setDeliveryLocation] = useState(initialAddressStateDelivery);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [salesRep, setSalesRep] = useState([]);
    const [salesTeam, setSalesTeam] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("Prospect");
    const { barValue, labelValue, color } =
    statusMap[selectedStatus] || statusMap.Lost;
    const [opportunityName, setOpportunityName] = useState("");
    // Pickup Address State'leri
    const [estimatedCloseDate, setEstimatedCloseDate] = useState(null);
    const [estimatedStartDate, setEstimatedStartDate] = useState(null);
    const [estimatedEndDate, setEstimatedEndDate] = useState(null);
    const [lastFollowupDate, setLastFollowupDate] = useState(null);
    const [nextFollowupDate, setNextFollowupDate] = useState(null);
    const [lastMeetingDate, setLastMeetingDate] = useState(null);
    const [nextMeetingDate, setNextMeetingDate] = useState(null);
    const [selectedFrequency, setSelectedFrequency] = useState("");
    const [lostReason, setLostReason] = useState("");
    const [avgMonthlyShipment, setAvgMonthlyShipment] = useState("");
    const [avgWeight, setAvgWeight] = useState("");
    const [avgCBM, setAvgCBM] = useState("");
    const [description, setDescription] = useState("");
    const [selectedPickupCountry, setSelectedPickupCountry] = useState(null);
    const [selectedDeliveryCountry, setSelectedDeliveryCountry] = useState(null);
    const [selectedTransport, setSelectedTransport] = useState("");
    const [selectedContainers, setSelectedContainers] = useState("");
    const [freightRate, setFreightRate] = useState("");
    const [freightRateCurrency, setFreightRateCurrency] = useState("");
    const [grossProfitType, setGrossProfitType] = useState("");
    const [perTruckProfit, setPerTruckProfit] = useState("");
    const [percentageProfit, setPercentageProfit] = useState("");
    const [percentageGrossProfit, setPercentageGrossProfit] = useState(0);
    const [perTruckGrossProfit, setPerTruckGrossProfit] = useState("");
    const [totalRevenue, setTotalRevenue] = useState("");
    const [pricePer20DC, setPricePer20DC] = useState("");
    const [pricePer40HC, setPricePer40HC] = useState("");
    const [container20DC, setContainer20DC] = useState("");
    const [container40HC, setContainer40HC] = useState("");
    const [totalRevenueSum, setTotalRevenueSum] = useState(0);
    const [totalPerTruckProfitSum, setTotalPerTruckProfitSum] = useState(0);
    const [totalPercentageGrossProfitSum, setTotalPercentageGrossProfitSum] = useState(0);
    const [paymentTerms, setPaymentTerms] = useState("");
    const [selectedPaymentPerformance, setSelectedPaymentPerformance] = useState("");
    const [operationalChallenges, setOperationalChallenges] = useState("");
    const [competingFreightForwarders, setCompetingFreightForwarders] = useState("");
    const [competingTransportCompanies, setCompetingTransportCompanies] = useState("");
    const [selectedPriceComparison, setSelectedPriceComparison] = useState("");
    const [selectedLoyalty, setSelectedLoyalty] = useState("");
    const [selectedCustomerCategory, setSelectedCustomerCategory] = useState("");
    const [winRate, setWinRate] = useState("");
    const [transitHubs, setTransitHubs ] = useState("");
    const [transportModeIntermodal, setTransportModeIntermodal] = useState("");
    const [selectedForwarder, setSelectedForwarder] = useState("");
    const [estimatedBuyingRates, setEstimatedBuyingRates] = useState("");
    const [grossProfitRate, setGrossProfitRate] = useState("");
    const [competitorsList, setCompetitorsList] = useState([]);
    const [showButtons, setShowButtons] = useState(!selectedCustomer);
    const [customerType, setCustomerType] = useState(selectedCustomer ? selectedCustomer.type : null);
    const [polOptions, setPolOptions] = useState([]);
    const [podOptions, setPodOptions] = useState([]);
    const [selectedPol, setSelectedPol] = useState(null);
    const [selectedPod, setSelectedPod] = useState(null);
    const [polInputValue, setPolInputValue] = useState("");
    const [podInputValue, setPodInputValue] = useState("");
    const [polLoading, setPolLoading] = useState(false);
    const [podLoading, setPodLoading] = useState(false);

    const polAbortRef = useRef(null);
    const podAbortRef = useRef(null);

// edit hydrate için: ilk yüklemede “temizleme” yapma
    const prevPolCountryRef = useRef(undefined);
    const prevPodCountryRef = useRef(undefined);






    const pickArray = (resp) => {
        const d = resp?.data;
        if (Array.isArray(d)) return d;
        if (Array.isArray(d?.data)) return d.data;
        return [];
    };

    const asOpt = (type, item) => {
        if (typeof item === "string") {
            const label = item.trim();
            if (!label) return null;
            const id = `${type}:${label.toLowerCase()}`;
            return { type, id, label, raw: item };
        }

        const label =
            item?.name ||
            item?.label ||
            item?.cityName ||
            item?.portName ||
            item?.airportName ||
            "";

        const rawId = item?.id || item?._id || item?.code || item?.iata || item?.name || label;
        const id = `${type}:${String(rawId).toLowerCase()}`;
        if (!label) return null;

        return { type, id, label, raw: item };
    };

    const uniqById = (arr) => {
        const m = new Map();
        arr.forEach((o) => {
            if (!o?.id) return;
            if (!m.has(o.id)) m.set(o.id, o);
        });
        return [...m.values()];
    };


    useEffect(() => {
        const country = selectedPickupCountry?.label;

        if (!country) {
            polAbortRef.current?.abort?.();
            setPolOptions([]);
            setSelectedPol(null);
            setPolInputValue("");
            setPolLoading(false);
            setPickupLocation(p => ({ ...p, pickupCity: "" }));
            return;
        }

        polAbortRef.current?.abort?.();
        const controller = new AbortController();
        polAbortRef.current = controller;

        (async () => {
            try {
                setPolLoading(true);

                const [seaportsResp, airportsResp, citiesResp] = await Promise.all([
                    CrudService.getSeaportsByCountryOpp(country, { signal: controller.signal }),
                    CrudService.getAirportsByCountryOpp(country, { signal: controller.signal }),
                    CrudService.getCitiesByCountryOpp(country, { signal: controller.signal }),
                ]);

                const seaports = pickArray(seaportsResp).map(x => asOpt("SEAPORT", x)).filter(Boolean);
                const airports = pickArray(airportsResp).map(x => asOpt("AIRPORT", x)).filter(Boolean);
                const cities   = pickArray(citiesResp).map(x => asOpt("CITY", x)).filter(Boolean);

                // İstenen sıra: SEAPORT -> AIRPORT -> CITY
                const ordered = [...seaports, ...airports, ...cities];

                // Eğer uniqById kullanacaksan tek sefer:
                setPolOptions(uniqById(ordered));
                // uniqById yoksa:
                // setPolOptions(ordered);

            } catch (e) {
                if (e?.name === "AbortError" || e?.code === "ERR_CANCELED" || e?.name === "CanceledError") return;
                console.warn("POL lists error:", e);
                setPolOptions([]);
            } finally {
                setPolLoading(false);
            }
        })();

        return () => controller.abort();
    }, [selectedPickupCountry]);

    useEffect(() => {
        const country = selectedDeliveryCountry?.label;

        if (!country) {
            podAbortRef.current?.abort?.();
            podAbortRef.current = null;

            setPodOptions([]);
            setSelectedPod(null);
            setPodInputValue("");
            setPodLoading(false);
            setDeliveryLocation((p) => ({ ...p, deliveryCity: "" }));
            return;
        }

        podAbortRef.current?.abort?.();

        const controller = new AbortController();
        podAbortRef.current = controller;

        (async () => {
            try {
                setPodLoading(true);

                const [citiesResp, seaportsResp, airportsResp] = await Promise.all([
                    CrudService.getCitiesByCountryOpp(country, { signal: controller.signal }),
                    CrudService.getSeaportsByCountryOpp(country, { signal: controller.signal }),
                    CrudService.getAirportsByCountryOpp(country, { signal: controller.signal }),
                ]);

                const seaports = pickArray(seaportsResp).map(x => asOpt("SEAPORT", x)).filter(Boolean);
                const airports = pickArray(airportsResp).map(x => asOpt("AIRPORT", x)).filter(Boolean);
                const cities   = pickArray(citiesResp).map(x => asOpt("CITY", x)).filter(Boolean);

                // ✅ İstenen sıra: SEAPORT -> AIRPORT -> CITY
                const ordered = [...seaports, ...airports, ...cities];

                setPodOptions(uniqById(ordered));
            } catch (e) {
                if (e?.name === "AbortError" || e?.code === "ERR_CANCELED" || e?.name === "CanceledError") return;
                console.warn("POD lists error:", e);
                setPodOptions([]);
            } finally {
                if (!controller.signal.aborted) setPodLoading(false);
            }
        })();

        return () => controller.abort();
    }, [selectedDeliveryCountry?.label]);


    // Generic state handler
    const handleStateChange = (setter, key, value) => {
        setter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        const opportunityData = {
            customer: selectedCustomer?.name || "Unknown Customer",
            opportunityName,
            salesRep: salesRep.map(rep => rep.id),
            salesTeam: salesTeam.map(rep => rep.id),
            pickupLocation: {
                ...pickupLocation,
                selectedPickupCountry: selectedPickupCountry ? selectedPickupCountry.label : ""
            },
            deliveryLocation: {
                ...deliveryLocation,
                selectedDeliveryCountry: selectedDeliveryCountry ? selectedDeliveryCountry.label : ""
            },
            estimatedCloseDate,
            estimatedStartDate,
            estimatedEndDate,
            lastFollowupDate,
            nextFollowupDate,
            lastMeetingDate,
            nextMeetingDate,
            frequency: selectedFrequency,
            status: selectedStatus,
            lostReason,
            description,
            avgMonthlyShipment,
            avgWeight,
            avgCBM,
            selectedTransportType,
            truckType: selectedTransport ? selectedTransport.label : "",
            containers: selectedContainers ? selectedContainers.label : "",
            freightRate,
            freightRateCurrency,
            totalRevenue,
            grossProfitType,
            perTruckProfit: grossProfitType === "perTruck" ? perTruckProfit : null,
            perTruckGrossProfit: grossProfitType === "perTruck" ? perTruckGrossProfit : null,
            percentageProfit: grossProfitType === "percentage" ? percentageProfit : null,
            percentageGrossProfit: grossProfitType === "percentage" ? percentageGrossProfit : null,
            pricePer20DC,
            pricePer40HC,
            container20DC,
            container40HC,
            totalRevenueSum,
            totalPerTruckProfitSum,
            totalPercentageGrossProfitSum,
            paymentTerms,
            paymentPerformance: selectedPaymentPerformance,
            operationalChallenges,
            competingFreightForwarders,
            competingTransportCompanies,
            priceComparison: selectedPriceComparison,
            loyalty: selectedLoyalty,
            customerCategory: selectedCustomerCategory,
            winRate,
            transitHubs,
            transportModeIntermodal,
            forwarder: selectedForwarder,
            estimatedBuyingRates,
            grossProfitRate,
            strategies: selectedStrategies,
            selectedKeyMarkets
        };


        try {
            setLoading(true);

            let response;
            if (isEditing) {
                response = await CrudService.updateOpportunity(opportunityData, opportunityId);
                setSuccessMessage("Update operation was successfully completed.");
            } else {
                response = await CrudService.createOpportunity({
                    data: opportunityData,
                });
                setSuccessMessage("Create operation was successfully completed.");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            setTimeout(() => {
                navigate("/opportunity/opportunity-tables/details");
            }, 3000);
        } catch (err) {
            console.error("Request failed: ", err);
        } finally {
            setLoading(false);
        }
    };

    const customerFromMeeting = searchParams.get("customer");

    useEffect(() => {
        if (customerFromMeeting) {
            setSelectedCustomer({ name: customerFromMeeting });
        }
    }, [customerFromMeeting]);


    useEffect(() => {
        if (opportunityData && truckType.length > 0 && containerOptions.length > 0) {
            setSelectedTransport(
                truckType.find(opt => opt.label.toLowerCase() === opportunityData.truckType?.toLowerCase()) || null
            );

            setSelectedContainers(
                containerOptions.find(opt => opt.label.toLowerCase() === opportunityData.container?.toLowerCase()) || null
            );
        }
    }, [opportunityData, truckType, containerOptions, isEditing]); // Bağımlılıklar tamamlandı


    useEffect(() => {
        const earnings = parseFloat(freightRate) || 0;
        const shipments = parseFloat(avgMonthlyShipment) || 0;
        const cbm = parseFloat(avgCBM) || 1;

        let calculatedRevenue = 0;

        calculatedRevenue = earnings * shipments; // 🔥 LCL = Earnings x Monthly Shipments x CBM

        setTotalRevenue(calculatedRevenue);
    }, [freightRate, avgMonthlyShipment, avgCBM, container20DC, container40HC, pricePer20DC, pricePer40HC]); // 🔥 Değerlerden biri değişince hesaplama yapılacak


// 📌 Anlık olarak Per Truck Gross Profit hesapla
    useEffect(() => {
        setPerTruckGrossProfit(parseFloat(perTruckProfit) * parseFloat(avgMonthlyShipment) || 0);
    }, [perTruckProfit, avgMonthlyShipment]);

// 📌 Anlık olarak Percentage Gross Profit hesapla
    useEffect(() => {
        const revenue = parseFloat(totalRevenue) || 0;
        const profitPercentage = parseFloat(percentageProfit) || 1;
        setPercentageGrossProfit(revenue * (profitPercentage/100));
    }, [totalRevenue, percentageProfit]);


    useEffect(() => {
        if (opportunityData) {
            setFreightRate(opportunityData.freightRate || "");
            setFreightRateCurrency(opportunityData.freightRateCurrency || "");
            setTotalRevenue(opportunityData.totalRevenue || 0);
            setGrossProfitType(opportunityData.grossProfitType || "");
            setPerTruckProfit(opportunityData.perTruckProfit ?? "");
            setPerTruckGrossProfit(opportunityData.perTruckGrossProfit ?? "");
            setPercentageProfit(opportunityData.percentageProfit ?? "");
            setPercentageGrossProfit(opportunityData.percentageGrossProfit ?? "");
            setEstimatedBuyingRates(opportunityData.estimatedBuyingRates || "");
            setGrossProfitRate(opportunityData.grossProfitRate || "");
        }
    }, [opportunityData]);

    useEffect(() => {
        if (opportunityData && typeof opportunityData.containers === "string") {
            const matchedContainer = containerOptions.find(opt =>
                opt.label.toLowerCase() === opportunityData.containers.toLowerCase()
            );
            setSelectedContainers(matchedContainer || null); // Eğer eşleşme yoksa `null` ata
        }
    }, [opportunityData, containerOptions]);

    useEffect(() => {
        if (opportunityData) {
            setPaymentTerms(opportunityData.paymentTerms || "");
            setSelectedPaymentPerformance(opportunityData.paymentPerformance || "");
            setOperationalChallenges(opportunityData.operationalChallenges || "");
            setCompetingFreightForwarders(opportunityData.competingFreightForwarders || "");
            setCompetingTransportCompanies(opportunityData.competingTransportCompanies || "");
            setSelectedPriceComparison(opportunityData.priceComparison || "");
            setSelectedLoyalty(opportunityData.loyalty || "");
            setSelectedCustomerCategory(opportunityData.customerCategory || "");
            setWinRate(opportunityData.winRate || "");
            setTransitHubs(opportunityData.transitHubs || "");
            setTransportModeIntermodal(opportunityData.transportModeIntermodal || "");
            setSelectedForwarder(opportunityData.forwarder || "");

        }
    }, [opportunityData]);

    const [avgMonthlyShipmentLabel, setAvgMonthlyShipmentLabel] = useState("Avg. Monthly Shipments");

    useEffect(() => {
        if (selectedFrequency) {
            setAvgMonthlyShipmentLabel(`Avg. ${selectedFrequency} Shipments`);
        }
    }, [selectedFrequency]);

    // Otomatik olarak brüt kâr oranını hesapla: (ciro - maliyet) / ciro * 100
    useEffect(() => {
        const cost = parseFloat(estimatedBuyingRates);
        const revenue = parseFloat(totalRevenue);
        if (!isNaN(cost) && !isNaN(revenue) && revenue > 0) {
            const rate = ((revenue - cost) / revenue) * 100;
            setGrossProfitRate(rate.toFixed(2));
        } else {
            setGrossProfitRate('');
        }
    }, [estimatedBuyingRates, totalRevenue]);


    useEffect(() => {
        CrudService.getCompetitors()
            .then(resp => {
                const names = resp.data.map(item => item.attributes.competitorCompany)
                    .filter(Boolean);
                setCompetitorsList(names);
            })
            .catch(err => console.error(err));
    }, []);

    const handleExistingClick = () => {
        setCustomerType("existing");
        setShowButtons(false); // Butonları gizle
    };

    const handleProspectClick = () => {
        setShowButtons(false); // Butonları gizle
        navigate("/meeting/create-meeting/details");
    };

    const handleProspectGlobalAgentClick = () => {
        setShowButtons(false); // Butonları gizle
        navigate("/global-agent/create-global-agent/details");
    };

    useEffect(() => {
        if (isEditing) {
            setShowButtons(false);
        }
    }, [isEditing]);

    useEffect(() => {
        if (selectedCustomer) {
            setCustomerType("existing"); // bu satır önemli!
            setShowButtons(false);
        }
    }, [selectedCustomer]);

    useEffect(() => {
        if (isEditing) {
            if (!selectedCustomer) {
                setShowButtons(true); // Edit modunda ve müşteri yoksa butonlar gözüksün
            } else {
                setShowButtons(false); // Müşteri varsa gizle
            }
        }
    }, [isEditing, selectedCustomer]);

    const [strategies, setStrategies] = useState([]);
    const [selectedStrategies, setSelectedStrategies] = useState([]);
    const [selectedKeyMarkets, setSelectedKeyMarkets] = useState({});
    const [expanded, setExpanded] = useState([]);
    useEffect(() => {
        CrudService.getStrategies()
            .then(({ data }) => setStrategies(data.map(({ id, attributes }) => ({ id, ...attributes }))))
            .catch(console.error);
    }, []);
    const kmKey = (strategyId, km, idx) => km.id || km._id || `${strategyId}-${idx}`;
    const toStr = (x) => typeof x === "string" ? x : x?.label || x?.value || x?.code || x?.name || "";
    const sum = (arr) => arr.reduce((a, b) => a + b, 0);

    const toggleExpand = (id) => setExpanded((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
    const toggleSelectStrategy = (id) =>
        setSelectedStrategies((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
    const calcTotalScore = (s) => sum((s.keyMarkets || []).map((k) => Number(k.score || 0)));

    const toggleKM = (sId, kmId) => {
        if (!kmId) return;
        setSelectedKeyMarkets((prev) => {
            const cur = prev[sId] || [];
            const next = cur.includes(kmId)
                ? cur.filter((x) => x !== kmId)
                : [...cur, kmId];

            const updated = { ...prev, [sId]: next };
            if (next.length === 0) delete updated[sId];
            return updated;
        });
    };



    const mainRows = useMemo(() =>
        strategies.map((s) => {
            const km = s.keyMarkets || [];
            const exp = expanded.includes(s.id);
            const score = calcTotalScore(s);

            return {
                id: s.id,
                select: (
                    <Checkbox
                        checked={selectedStrategies.includes(s.id)}
                        onChange={() => toggleSelectStrategy(s.id)}
                    />
                ),
                details: km.length > 1 ? (
                    <IconButton size="small" onClick={() => toggleExpand(s.id)}>
                        {exp ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                ) : (
                    ""
                ),
                strategyName: (
                    <Link
                        to={`/strategy/create-strategy/details?id=${encodeURIComponent(s.id)}`}
                        style={{ textDecoration: "none", color: "#1976d2", fontWeight: 500 }}
                    >
                        {s.strategyName || "-"}
                    </Link>
                ),
                continent: km.map((k) => toStr(k.continent) || toStr(k.region)).filter(Boolean).join(", "),
                countries: km.flatMap((k) => (k.countries || []).map(toStr)).filter(Boolean).join(", "),
                score,
                incoterms: km.flatMap((k) => (k.selectedIncoterm || []).map(toStr)).filter(Boolean).join(", "),
                shippingPreferences: km.flatMap((k) => (k.shippingPreferences || []).map(toStr)).filter(Boolean).join(", "),
                industries: km.flatMap((k) => (k.industry || []).map(toStr)).filter(Boolean).join(", "),
                _km: km,
            };
        }), [strategies, selectedStrategies, expanded]);

    const rows = useMemo(() => {
        const out = [];
        mainRows.forEach((r) => {
            out.push(r);
            if (expanded.includes(r.id)) {
                r._km.forEach((km, idx) => {
                    const strategyId = r.id;
                    const kmId = km.id || km._id || `${strategyId}-${idx}`;

                    out.push({
                        id: `${strategyId}-km-${idx}`,
                        strategyId,  // ayrı geçiriyoruz
                        kmId,        // km'nin ID'si
                        select: null,  // Checkbox’ı sonra ekleyeceğiz
                        details: "",
                        strategyName: "",
                        continent: toStr(km.continent) || toStr(km.region) || "-",
                        countries: (km.countries || []).map(toStr).join(", ") || "-",
                        score: km.score || "-",
                        incoterms: (km.selectedIncoterm || []).map(toStr).join(", "),
                        shippingPreferences: (km.shippingPreferences || []).map(toStr).join(", "),
                        industries: (km.industry || []).map(toStr).join(", "),
                    });
                });

            }
        });
        return out;
    }, [mainRows, expanded, selectedKeyMarkets]);

    const table = useMemo(() => ({
        columns: [
            { Header: "Select", accessor: "select", width: "5%" },
            { Header: "#", accessor: "details", width: "5%" },
            { Header: "Strategy", accessor: "strategyName" },
            { Header: "Continents", accessor: "continent" },
            { Header: "Countries", accessor: "countries" },
            { Header: "Total Score", accessor: "score" },
            { Header: "Incoterms", accessor: "incoterms" },
            { Header: "Shipping Prefs", accessor: "shippingPreferences" },
            { Header: "Industries", accessor: "industries" },
        ],
        rows,
    }), [rows]);
    rows.forEach((row) => {
        if (row.strategyId && row.kmId) {
            row.select = (
                <Checkbox
                    checked={(selectedKeyMarkets[row.strategyId] || []).includes(row.kmId)}
                    onChange={() => toggleKM(row.strategyId, row.kmId)}
                />
            );
        }
    });


    useEffect(() => {
        if (!isEditing) return;
        if (!polOptions?.length) return;

        const wantedLabel = pickupLocation?.pickupCity;
        if (!wantedLabel) return;

        // zaten seçiliyse dokunma
        if (selectedPol?.label === wantedLabel) return;

        const found = polOptions.find(o => (o?.label || "").toLowerCase() === wantedLabel.toLowerCase());
        if (found) {
            setSelectedPol(found);
            setPolInputValue(found.label);
        }
    }, [isEditing, polOptions, pickupLocation?.pickupCity]);


    useEffect(() => {
        if (!isEditing) return;
        if (!podOptions?.length) return;

        const wantedLabel = deliveryLocation?.deliveryCity;
        if (!wantedLabel) return;

        if (selectedPod?.label === wantedLabel) return;

        const found = podOptions.find(o => (o?.label || "").toLowerCase() === wantedLabel.toLowerCase());
        if (found) {
            setSelectedPod(found);
            setPodInputValue(found.label);
        }
    }, [isEditing, podOptions, deliveryLocation?.deliveryCity]);


    return (
        <Grid container spacing={0} justifyContent="center" mb={1}>
            <Grid item xs={12} lg={10}>
                <MDBox mb={2}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            <MDBox mb={1}>
                                <div ref={successMessageRef}>
                                    {successMessage && <CrmNotice sx={{ mb: 2 }}>{successMessage}</CrmNotice>}
                                </div>
                                <CrmPageHeader title={(isEditing
                                            ? " Edit INTERMODAL Opportunity Details"
                                            : " Add INTERMODAL Opportunity Details").trim()} subtitle="This information will give you more information about the Opportunity for INTERMODAL." />
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                < MDBox mt={3}
                        sx={{
                            ...crmCardSx,
                            overflow: "visible",
                            p: 3,
                        }}>
                    <MDBox mb={3}>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} lg={12}>
                                <MDBox>
                                    <MDBox mt={3}>
                                        <Grid container spacing={3} alignItems="center">
                                            <Grid item xs={6}>
                                                <MDTypography variant="h5" component="div">
                                                    General Opportunity Information
                                                </MDTypography>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={3}>
                                        <Grid container spacing={3}>

                                            {/* EXISTING / PROSPECT BUTTONS */}
                                            <Grid item xs={12} sm={6}>
                                                {showButtons ? (
                                                    <MDBox mb={1} display="flex" gap={1}>
                                                        <Button
                                                            variant="contained"
                                                            style={{
                                                                backgroundColor: "#04c8e3",
                                                                color: "#FFFFFF",
                                                                padding: "10px 20px"
                                                            }}
                                                            onClick={handleExistingClick}
                                                        >
                                                            Existing Customer
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                            backgroundColor: "#FFFFFF",
                                            color: "#101828 !important",
                                            border: "1px solid rgba(15, 23, 42, 0.12)",
                                            padding: "10px 20px",
                                            borderRadius: "8px",
                                            textTransform: "none",
                                            fontWeight: 600,
                                            boxShadow: "none",
                                            "&:hover": { backgroundColor: "#FFFFFF", borderColor: "#175CD3", color: "#175CD3 !important", boxShadow: "none" },
                                        }}
                                                            onClick={handleProspectClick}
                                                        >
                                                            Prospect Customer
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            style={{
                                                                backgroundColor: "#061a9e",
                                                                color: "#FFFFFF",
                                                                padding: "10px 20px"
                                                            }}
                                                            onClick={handleProspectGlobalAgentClick}
                                                        >
                                                            Prospect Global Agent
                                                        </Button>
                                                    </MDBox>
                                                ) : (
                                                    customerType === "existing" && (
                                                        <Autocomplete
                                                            value={selectedCustomer}
                                                            onChange={(event, newValue) => setSelectedCustomer(newValue)}
                                                            options={customerOptions}
                                                            getOptionLabel={(option) => option?.name || ""}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Customer"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                />
                                                            )}
                                                        />
                                                    )
                                                )}
                                            </Grid>

                                            {/* CUSTOMER CATEGORY */}
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={customerCategoryOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedCustomerCategory ? { label: selectedCustomerCategory } : null}
                                                    onChange={(event, newValue) =>
                                                        setSelectedCustomerCategory(newValue ? newValue.label : "")
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Customer Category"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            {/* OPPORTUNITY NAME */}
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Opportunity Name"
                                                    value={opportunityName}
                                                    onChange={(e) => setOpportunityName(e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <Grid container spacing={2}>

                                            {/* Transport Type */}
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Transport Type"
                                                    value={selectedTransportType}
                                                    disabled
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            {/* Estimated Start Date */}
                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Estimated Start Date"
                                                        value={estimatedStartDate}
                                                        onChange={(newValue) => setEstimatedStartDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: { "& .MuiInputBase-root": { height: 40 } }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            {/* Estimated End Date */}
                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Estimated End Date"
                                                        value={estimatedEndDate}
                                                        onChange={(newValue) => setEstimatedEndDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: { "& .MuiInputBase-root": { height: 40 } }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            {/* Estimated Close Date */}
                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Estimated Close Date"
                                                        value={estimatedCloseDate}
                                                        onChange={(newValue) => setEstimatedCloseDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: { "& .MuiInputBase-root": { height: 40 } }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            {/* Frequency */}
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={frequencyOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedFrequency ? { label: selectedFrequency } : null}
                                                    onChange={(event, newValue) =>
                                                        setSelectedFrequency(newValue ? newValue.label : "")
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Frequency"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <Grid container spacing={2}>

                                            {/* Status + Progress */}
                                            <Grid item xs={12} sm={3}>
                                                <Box>

                                                     <Autocomplete
                                                        options={statusOptions}
                                                        getOptionLabel={(opt) => opt.label}
                                                        value={selectedStatus ? { label: selectedStatus } : null}
                                                        onChange={(_, newVal) => setSelectedStatus(newVal ? newVal.label : "Prospect")}
                                                        isOptionEqualToValue={(opt, val) => opt.label === val.label}
                                                        disableClearable

                                                        // ✅ dropdown seçenekleri dot'lu
                                                        renderOption={({ key: optionKey, ...props }, option) => (
                                                            <li {...props} key={option.label}>
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                    <StatusDot status={option.label} />
                                                                    <span>{option.label}</span>
                                                                </Box>
                                                            </li>
                                                        )}


                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Business Status"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        height: 40,
                                                                        alignItems: "center", // ✅ kritik
                                                                    },
                                                                }}
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    startAdornment: selectedStatus ? (
                                                                        <InputAdornment position="start" sx={{ m: 0 }}>
                                                                            <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                                                                                <StatusDot status={selectedStatus} />
                                                                            </Box>
                                                                        </InputAdornment>
                                                                    ) : (
                                                                        params.InputProps.startAdornment
                                                                    ),
                                                                }}
                                                            />
                                                        )}

                                                    />

                                                    {/* Progress bar + % */}
                                                    <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                                                        <Box sx={{ flexGrow: 1 }}>
                                                            <ProgressBar barValue={barValue} color={color} />
                                                        </Box>
                                                        <Box sx={{ ml: 1, minWidth: 40 }}>
                                                            <Typography variant="body2" color="text.secondary">
                                                                {labelValue}%
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                </Box>
                                            </Grid>

                                            {/* Lost Reason */}
                                            {selectedStatus === "Lost" && (
                                                <Grid item xs={12} sm={9}>
                                                    <TextField
                                                        fullWidth
                                                        label="Lost Reason"
                                                        value={lostReason}
                                                        onChange={(e) => setLostReason(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>
                                            )}

                                            {/* Opportunity Owner */}
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    multiple
                                                    options={salesRepOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={salesRep}
                                                    onChange={(event, newValues) => setSalesRep(newValues)}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Opportunity Owner"
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            {/* Sales Team */}
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    multiple
                                                    options={salesRepOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={salesTeam}
                                                    onChange={(event, newValues) => setSalesTeam(newValues)}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Sales Representatives"
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                        </Grid>
                                    </MDBox>
                                    {/* Pickup & Delivery Location - Aynı Satırda */}
                                    <MDBox mt={3}>
                                        <Grid container spacing={3} alignItems="center">

                                            {/* ORIGIN */}
                                            <Grid item xs={6}>
                                                <MDTypography variant="h5">Origin</MDTypography>

                                                <MDBox mt={2}>
                                                    <Grid container spacing={2} alignItems="center">

                                                        {/* Country */}
                                                        <Grid item xs={4}>
                                                            <Autocomplete
                                                                options={countryOptions}
                                                                getOptionLabel={(o) => o.label}
                                                                value={selectedPickupCountry}
                                                                onChange={(_, newVal) => {
                                                                    setSelectedPickupCountry(newVal);
                                                                    setPickupLocation((prev) => ({
                                                                        ...prev,
                                                                        selectedPickupCountry: newVal ? newVal.label : "",
                                                                    }));
                                                                }}

                                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                                    <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                                        <img src={option.flagUrl} width={24} height={16} style={{ borderRadius: 3 }} />
                                                                        {option.label}
                                                                    </li>
                                                                )}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="POL Country"
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>

                                                        {/* City */}
                                                        <Grid item xs={4}>
                                                            <Autocomplete
                                                                options={polOptions}
                                                                value={selectedPol}
                                                                inputValue={polInputValue}
                                                                loading={polLoading}
                                                                onInputChange={(_, v) => setPolInputValue(v)}
                                                                onChange={(_, opt) => {
                                                                    setSelectedPol(opt);
                                                                    setPickupLocation(p => ({
                                                                        ...p,
                                                                        pickupPlaceType: opt?.type || "",
                                                                        pickupPlaceId: opt?.id || "",
                                                                        pickupCity: opt?.label || "",
                                                                    }));
                                                                }}
                                                                groupBy={(opt) => opt.type}  // CITY / SEAPORT / AIRPORT
                                                                getOptionLabel={(opt) => opt?.label || ""}
                                                                isOptionEqualToValue={(o, v) => `${o?.type}-${o?.id}` === `${v?.type}-${v?.id}`}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="POL (Seaport / Airport / City)"
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                    />
                                                                )}
                                                            />

                                                        </Grid>

                                                        {/* Additional Info */}
                                                        <Grid item xs={4}>
                                                            <TextField
                                                                type="text"
                                                                label="Additional Info"
                                                                value={pickupLocation.additionalInfo}
                                                                onChange={(e) =>
                                                                    handleStateChange(setPickupLocation, "additionalInfo", e.target.value)
                                                                }
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </MDBox>
                                            </Grid>

                                            {/* DESTINATION */}
                                            <Grid item xs={6}>
                                                <MDTypography variant="h5">Destination</MDTypography>

                                                <MDBox mt={2}>
                                                    <Grid container spacing={2} alignItems="center">

                                                        {/* Country */}
                                                        <Grid item xs={4}>
                                                            <Autocomplete
                                                                options={countryOptions}
                                                                getOptionLabel={(o) => o.label}
                                                                value={selectedDeliveryCountry}
                                                                onChange={(_, newVal) => {
                                                                    setSelectedDeliveryCountry(newVal);
                                                                    setDeliveryLocation((prev) => ({
                                                                        ...prev,
                                                                        selectedDeliveryCountry: newVal ? newVal.label : "",
                                                                    }));
                                                                }}

                                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                                    <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                                        <img src={option.flagUrl} width={24} height={16} style={{ borderRadius: 3 }} />
                                                                        {option.label}
                                                                    </li>
                                                                )}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="POD Country"
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>

                                                        {/* City */}
                                                        <Grid item xs={4}>
                                                            <Autocomplete
                                                                options={podOptions}
                                                                value={selectedPod}
                                                                inputValue={podInputValue}
                                                                loading={podLoading}
                                                                onInputChange={(_, v) => setPodInputValue(v)}
                                                                onChange={(_, opt) => {
                                                                    setSelectedPod(opt);
                                                                    setDeliveryLocation(p => ({
                                                                        ...p,
                                                                        deliveryCity: opt?.label || "",
                                                                        deliveryPlaceType: opt?.type || "",
                                                                        deliveryPlaceId: opt?.id || "",
                                                                    }));
                                                                }}
                                                                groupBy={(opt) => opt.type} // CITY / SEAPORT / AIRPORT
                                                                getOptionLabel={(opt) => opt?.label || ""}

                                                                // ✅ type + id ile eşitle: (CITY-1) ile (AIRPORT-1) çakışmasın
                                                                isOptionEqualToValue={(o, v) => `${o?.type}-${o?.id}` === `${v?.type}-${v?.id}`}

                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="POD (Seaport / Airport / City)"
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                    />
                                                                )}
                                                            />

                                                        </Grid>

                                                        {/* Additional Info */}
                                                        <Grid item xs={4}>
                                                            <TextField
                                                                type="text"
                                                                label="Additional Info"
                                                                value={deliveryLocation.additionalInfo}
                                                                onChange={(e) =>
                                                                    handleStateChange(setDeliveryLocation, "additionalInfo", e.target.value)
                                                                }
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </MDBox>
                                            </Grid>
                                        </Grid>

                                        {/* TRANSIT / MODE / EQUIPMENT */}
                                        <MDBox mt={2}>
                                            <Grid container spacing={3} mt={3} alignItems="center">

                                                {/* Transit Hubs */}
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        type="text"
                                                        label="Transit Hubs"
                                                        value={transitHubs}
                                                        onChange={(e) => setTransitHubs(e.target.value)}
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>

                                                {/* Transport Mode */}
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        type="text"
                                                        label="Transport Mode"
                                                        value={transportModeIntermodal}
                                                        onChange={(e) => setTransportModeIntermodal(e.target.value)}
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>

                                                {/* Equipment Type */}
                                                <Grid item xs={12} sm={3}>
                                                    <Autocomplete
                                                        options={truckType}
                                                        getOptionLabel={(o) => o.label}
                                                        value={selectedTransport || null}
                                                        onChange={(_, newVal) => setSelectedTransport(newVal)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Equipment Type"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </MDBox>

                                        {/* AVG WEIGHT / CBM */}
                                        <MDBox mt={2}>
                                            <Grid container spacing={3} mt={3} alignItems="center">

                                                {/* Avg Weight */}
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        type="text"
                                                        label="Avg. Weight"
                                                        value={avgWeight}
                                                        onChange={(e) => setAvgWeight(e.target.value)}
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>

                                                {/* Avg CBM */}
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        type="text"
                                                        label="Avg. CBM per Shipment"
                                                        value={avgCBM}
                                                        onChange={(e) => setAvgCBM(e.target.value)}
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </MDBox>


                                        {/* FINANCIAL DATA */}
                                        <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
                                            <Grid item xs={12}>
                                                <MDTypography variant="h5">Financial & Commercial Data</MDTypography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Grid container spacing={2} alignItems="center">

                                                    {/* Avg Shipments */}
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            type="text"
                                                            label={avgMonthlyShipmentLabel}
                                                            placeholder={`Enter ${avgMonthlyShipmentLabel}`}
                                                            value={avgMonthlyShipment}
                                                            onChange={(e) => setAvgMonthlyShipment(e.target.value)}
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    </Grid>

                                                    {/* Estimated Revenue */}
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            type="text"
                                                            label="Estimated Revenue for Per Shipment"
                                                            value={freightRate}
                                                            onChange={(e) => setFreightRate(e.target.value)}
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    </Grid>

                                                    {/* Currency */}
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            select
                                                            label="Currency"
                                                            value={freightRateCurrency}
                                                            onChange={(e) => setFreightRateCurrency(e.target.value)}
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        >
                                                            <MenuItem value="USD">USD</MenuItem>
                                                            <MenuItem value="EUR">EUR</MenuItem>
                                                            <MenuItem value="TRY">TRY</MenuItem>
                                                            <MenuItem value="GBP">GBP</MenuItem>
                                                        </TextField>
                                                    </Grid>

                                                    {/* Total Revenue */}
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            type="text"
                                                            label="Total Gross Revenue"
                                                            value={totalRevenue}
                                                            disabled
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </MDBox>
                                    <Grid container spacing={3} mt={3}>

                                        {/* Payment Terms */}
                                        <Grid item xs={4}>
                                            <TextField
                                                type="text"
                                                label="Payment Terms"
                                                value={paymentTerms}
                                                onChange={(e) => setPaymentTerms(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                            />
                                        </Grid>

                                        {/* Payment Performance */}
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                options={paymentPerformanceOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={
                                                    selectedPaymentPerformance ? { label: selectedPaymentPerformance } : null
                                                }
                                                onChange={(event, newValue) =>
                                                    setSelectedPaymentPerformance(newValue ? newValue.label : "")
                                                }
                                                isOptionEqualToValue={(o, v) => o.label === v.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Payment Performance"
                                                        InputLabelProps={{ shrink: true }}
                                                        fullWidth
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Operational Challenges */}
                                        <Grid item xs={4}>
                                            <TextField
                                                type="text"
                                                label="Operational Challenges"
                                                value={operationalChallenges}
                                                onChange={(e) => setOperationalChallenges(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                            />
                                        </Grid>

                                    </Grid>
                                    <br/>
                                    <MDTypography mt={3} variant="h5">Competitor Analysis</MDTypography>
                                    <Grid container spacing={3}>

                                        {/* Freight Forwarders */}
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                options={forwarderOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedForwarder ? { label: selectedForwarder } : null}
                                                onChange={(event, newValue) =>
                                                    setSelectedForwarder(newValue ? newValue.label : "")
                                                }
                                                isOptionEqualToValue={(option, value) => option.label === value.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Freight Forwarders"
                                                        InputLabelProps={{ shrink: true }}
                                                        fullWidth
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Competing Freight Forwarders */}
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                freeSolo
                                                options={competitorsList}
                                                value={competingFreightForwarders}
                                                onInputChange={(_, newValue) => setCompetingFreightForwarders(newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Competing Freight Forwarders"
                                                        InputLabelProps={{ shrink: true }}
                                                        fullWidth
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Competing Intermodal Operators */}
                                        <Grid item xs={4}>
                                            <TextField
                                                type="text"
                                                label="Competing Intermodal Operators"
                                                value={competingTransportCompanies}
                                                onChange={(e) => setCompetingTransportCompanies(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                            />
                                        </Grid>

                                    </Grid>

                                    <Grid container spacing={3} mt={3}>

                                        {/* Price Comparison */}
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                options={priceComparisonOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedPriceComparison ? { label: selectedPriceComparison } : null}
                                                onChange={(event, newValue) =>
                                                    setSelectedPriceComparison(newValue ? newValue.label : "")
                                                }
                                                isOptionEqualToValue={(option, value) => option.label === value.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Price Comparison"
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Customer Loyalty */}
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                options={loyaltyOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedLoyalty ? { label: selectedLoyalty } : null}
                                                onChange={(event, newValue) =>
                                                    setSelectedLoyalty(newValue ? newValue.label : "")
                                                }
                                                isOptionEqualToValue={(option, value) => option.label === value.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Customer Loyalty to Competitor"
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                    </Grid>

                                    <MDTypography mt={3} variant="h5">Customer Follow-up & Management</MDTypography>
                                    <Grid container spacing={3} mt={1}>

                                        {/* Last Follow-up Date */}
                                        <Grid item xs={12} sm={3}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Last Follow-up Date"
                                                    value={lastFollowupDate}
                                                    onChange={(newValue) => setLastFollowupDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            InputLabelProps: { shrink: true },
                                                            sx: { "& .MuiInputBase-root": { height: 40 } }
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {/* Next Follow-up Date */}
                                        <Grid item xs={12} sm={3}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Next Follow-up Date"
                                                    value={nextFollowupDate}
                                                    onChange={(newValue) => setNextFollowupDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            InputLabelProps: { shrink: true },
                                                            sx: { "& .MuiInputBase-root": { height: 40 } }
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {/* Last Meeting Date */}
                                        <Grid item xs={12} sm={3}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Last Meeting Date"
                                                    value={lastMeetingDate}
                                                    onChange={(newValue) => setLastMeetingDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            InputLabelProps: { shrink: true },
                                                            sx: { "& .MuiInputBase-root": { height: 40 } }
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {/* Next Scheduled Meeting Date */}
                                        <Grid item xs={12} sm={3}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Next Scheduled Meeting Date"
                                                    value={nextMeetingDate}
                                                    onChange={(newValue) => setNextMeetingDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            InputLabelProps: { shrink: true },
                                                            sx: { "& .MuiInputBase-root": { height: 40 } }
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {/* Win Rate (%) */}
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                type="text"
                                                label="Previous Deal Closing Rate (Win Rate %)"
                                                value={winRate}
                                                onChange={(e) => setWinRate(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">%</InputAdornment>
                                                    )
                                                }}
                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid container spacing={3} mt={5}>
                                        <Grid item xs={12}>
                                            <TextField
                                                type="text"
                                                label="Notes & Special Considerations"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={3}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{
                                                    "& .MuiInputBase-root": { minHeight: 40 }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <br/>

                                </MDBox>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} mt={8}>
                            <MDTypography variant="h6" mb={2}>
                                STRATEGIES
                            </MDTypography>
                            <MDBox p={2} boxShadow={1} bgcolor="#fafafa" borderRadius={2}>
                                <DataTable table={table}/>
                            </MDBox>
                        </Grid>
                    </MDBox>

                    <MDBox mt={5}>
                        <Grid container spacing={2} justifyContent="flex-start">
                            {/* Create Meeting Butonu - Sadece Meetings Sayfasından Gelmeyenler İçin */}
                            {!isFromMeetings && (
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => navigate("/meeting/create-meeting/details")}
                                        sx={{
                                            backgroundColor: "#FFFFFF",
                                            color: "#101828 !important",
                                            border: "1px solid rgba(15, 23, 42, 0.12)",
                                            padding: "10px 20px",
                                            borderRadius: "8px",
                                            textTransform: "none",
                                            fontWeight: 600,
                                            boxShadow: "none",
                                            "&:hover": { backgroundColor: "#FFFFFF", borderColor: "#175CD3", color: "#175CD3 !important", boxShadow: "none" },
                                        }}
                                    >
                                        Create Meeting
                                    </Button>
                                </Grid>
                            )}

                            {/* Create / Update Opportunity Butonu */}
                            <Grid item>
                                <form onSubmit={submitHandler}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        sx={{
                                            backgroundColor: "#0B1F3A",
                                            color: "#FFFFFF !important",
                                            padding: "10px 20px",
                                            borderRadius: "8px",
                                            textTransform: "none",
                                            fontWeight: 600,
                                            boxShadow: "none",
                                            "&:hover": { backgroundColor: "#12345B", boxShadow: "none" },
                                        }}
                                    >
                                        {isEditing ? "Update Opportunity" : "Create Opportunity"}
                                    </Button>
                                </form>
                            </Grid>
                        </Grid>
                    </MDBox>

                </MDBox>
            </Grid>
        </Grid>
    );
};

export default IntermodalForm;
